export default __webpack_public_path__ + "static/media/ToyotaSPMWhite.884dc4fc.png";